import React, {Component} from 'react';
const { connect } = require('react-redux');

import HeaderBrief from 'components/profile/HeaderBrief';
import NotFound from 'containers/NotFound';
import Loading from 'components/Loading';
import Registry from 'registry';

import {getProfileWishlist} from 'reducers/profileWishlist';

import '../../sass/profile/ProfileIndex.scss';
import '../../sass/profile/wishList.scss';

import {t, dt} from 'l10n';
import {Helmet} from "react-helmet";

class ProfileWishlist extends Component {
    static fetchData({dispatch, match}) {
        let {nick} = match.params;

        return dispatch(getProfileWishlist(nick));
    }

    componentDidMount() {
        let {dispatch, match, profileWishlist} = this.props,
            {user} = profileWishlist;

        if (!user || match.params.nick !== user.nick) {
            this.constructor.fetchData({dispatch, match});
        }
    }

    render() {
        let {match, profileWishlist} = this.props,
            {user, online, wishlist} = profileWishlist;

        if (!user) {
            return <Loading centered/>;
        }

        if (user._notFound) {
            return <NotFound {...this.props}/>
        }

        let BOBSTORE_URL = Registry.get('BOBSTORE_URL');

        return (
            <div id="wrapper">
                {user &&
                    <Helmet>
                        <title>{dt('meta', 'La liste d’envies de %1 sur BobTV | Webcam Live |', user.nick)}</title>
                        <meta name="description" content={dt('meta', 'Offrez un cadeau à %1 (%2) qui s’exhibe en Webcam et en direct sur les salons de discussion | 18+ |', user.nick, user.region || user.country)}/>
                    </Helmet>
                }
                <HeaderBrief user={user} online={online} match={match}/>
                <aside className="my-wishlist">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('Wishlist on')} <a href={BOBSTORE_URL} target="_blank">Bobstore</a>  <em>{wishlist.length || 0}</em></h2>
                            <span>{t('The gifts will be delivered to %1 by Bob in 3 days max!', user.nick)}</span>
                        </div>

                        <div className="list-wishlist ui-responsive-grid">
                            {wishlist.map((item, index) =>
                                <div key={index}>
                                    <div className="list-wishlist-item">
                                        <a className="img" target="_blank">
                                            <img src={item.thumbnail_url} alt={item.title}/>
                                        </a>
                                        <a href={item.buy_as_gift_url} target="_blank" className="basket"/>
                                        <div className="text">
                                            <p className="name-wishlist">
                                                {item.title}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        profileWishlist: state.profileWishlist,
        currentUser: state.currentUser
    }),
    null
)(ProfileWishlist);


// WEBPACK FOOTER //
// ./src/containers/profile/ProfileWishlist.js